// extracted by css-extract-rspack-plugin
export default {"form":"form-XG_cSa","inputRow":"inputRow-_lKoB5","numberField":"numberField-ahvatl","errorList":"errorList-jmyR6H"};